export default __webpack_public_path__ + "0a62d572c821bfd0ab118e664d5e85f6.png";